/**
 * Created by Xiaotao.Nie on 24/01/2018.
 * All right reserved
 * IF you have any question please email onlythen@yeah.net
 */

export const demoURL = 'https://www.easy-mock.com/mock/59d268c39cabc90bb5e5b5cf/timeline/timeline'

export const colorGrad = ['rgb(235, 237, 240)', 'rgb(198, 228, 139)', 'rgb(123, 201, 111)', 'rgb(35, 154, 59)', 'rgb(25, 97, 39)']

// export const colorGradActive = ['#feffe6', '#fffb8f', '#ffec3d', '#d4b106', '#876800']
export const colorGradActive = ['#e6fffb', '#87e8de', '#36cfc9', '#08979c', '#00474f']

export const type1 = 'YYYY-MM-DD'

export const type2 = 'YYYY-MM-DD HH:mm:ss'

export const monthShow = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']



// WEBPACK FOOTER //
// ./src/components/config.js